export function bitcashValidate(hiraganaId, price, callback) {
	return {
    type: 'BITCASH_VALIDATE',
		payload: {
			hiraganaId: hiraganaId,
      price: price,
		},
    callback: callback,
	}
};


export function bitcashSettle(bcs_id, price, days, callback) {
	return {
    type: 'BITCASH_SETTLE',
		payload: {
			bcs_id: bcs_id,
      price: price,
      days: days,
		},
    callback: callback,
	}
};
